/*global process*/

'use strict';

var superagent = require('superagent');
var when = require('when');
var debug = require('debug')('svtse:plainservice:debug');
var perf = require('debug')('svtse:plainservice:perf');

var DEFAULT_TIMEOUT = 60000;
var DEFAULT_USER_AGENT = (typeof process !== 'undefined' && process.env && process.env.USER_AGENT) ? process.env.USER_AGENT : 'svtse-render-default';


/**
 * Perform a GET request on the specified URL with the given parameters. It assumes that the
 * result is valid JSON
 *
 * Will return a promise that will be resolved with the parsed JSON response as argument. The
 * promise will be rejected if an error status code is returned, if the response is not valid
 * JSON or if a time out occurs.
 *
 * @param {string} url the URL to call
 * @param {Object} params optional map of parameters for the request
 * @param {Object} options optional options (e.g. timeout)
 * @returns {promise} a promise for the pending request
 */

module.exports.read = function (url, params, options) {
	var deferred = when.defer();
	var request = superagent.get(url);
	options = options || {};
	var timeout = isNaN(options.timeout) ? DEFAULT_TIMEOUT: parseInt(options.timeout, 10);

	// The browser will set the correct useragent,
	// but in node we could like du bea able to customize 
	// our header so we can identify which enviroment the
	// request are originating from.
	if (typeof window === 'undefined') {
		request = request.set('User-Agent', DEFAULT_USER_AGENT);
	}

	var startTime = (new Date()).getTime();

	request.set('Accept', 'application/json')
		.query(params)
		.timeout(timeout)
		.end(function (err, res) {
			var endTime = (new Date()).getTime();
			perf("Executed request in %sms (%s %o)", (endTime - startTime), url, params);
			if (res && res.error) {
				debug(res.error);
				deferred.reject({
					status: res.error.status,
					error: res.error
				});
			} else if (err) {
				debug(err);
				deferred.reject({
					status: err.status || 500,
					error: err
				});
			} else {
				deferred.resolve(res.body);
			}
		});

	return deferred.promise;
};


// Mimics the fetch API
module.exports.fetch = function (url) {
	const deferred = when.defer();
	const request = superagent.get(url);
	const startTime = (new Date()).getTime();

	// The browser will set the correct useragent,
	// but in node we could like du bea able to customize 
	// our header so we can identify which enviroment the
	// request are originating from.
	if (typeof window === 'undefined') {
		request.set('User-Agent', DEFAULT_USER_AGENT);
	}

	request.set('Accept', 'application/json')
		.timeout(DEFAULT_TIMEOUT)
		.end((err, res = {}) => {

			if (res.error && res.error.status && res.status === undefined) {
				res.status = res.error.status;
			}

			if (err && res.status === undefined) {
				res.status = err.status || 500;
			}

			res.json = () => when(res.body);

			perf("Executed request in %sms (%s %o)", ((new Date()).getTime() - startTime), url);

			deferred.resolve(res);

		});

	return deferred.promise;

};



/** WEBPACK FOOTER **
 ** ./app/plugins/ServicePlugin/plainService.js
 **/